<template>
  <v-img
    v-if="isShowItemNutriGrade(item)"
    :src="itemNutriGradeImageUrl(item)"
    height="23"
    width="43"
    class="food-nutri-grade-img"
  >
    <div class="food-nutri-grade-sugre-percent">{{ item.sugar_percent }}%</div>
  </v-img>
</template>

<script>
export default {
  props: ['item'],
  name: 'item-nutri-grade-tag',
  methods: {
    isShowItemNutriGrade (item) {
      return item && !!item.nutri_grade
    },
    itemNutriGradeImageUrl (item) {
      if (!item) {
        return undefined
      }

      let map = {
        1: '/assets/images/nutri_grade/a.png',
        2: '/assets/images/nutri_grade/b.png',
        3: '/assets/images/nutri_grade/c.png',
        4: '/assets/images/nutri_grade/d.png'
      }

      return map[item.nutri_grade]
    }
  }
}
</script>

<style scoped>
.food-nutri-grade-img {
  position: absolute;
  bottom: 2px;
  right: 2px;
}
.food-nutri-grade-sugre-percent {
  padding-left: 23px;
  padding-top: 3px;
  font-size: 9px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemNutriGradeTag.vue